/**
 * composition_v3's residual buckets, by id: `0` is unclassified, `-1` is
 * outside-the-top-N. go-api labels them `Other`, `other` or not at all, and a
 * real segment may be named "Other". In `libs/core` so the dashboard's
 * converters and dash-meta's workforce read drop the same rows.
 */
export const OTHER_BUCKET_LABEL = 'Other';

export const isEmptyCompositionBucket = (
  rowId: number | string | null | undefined
): boolean => rowId === 0 || rowId === '0';

export const isOtherCompositionBucket = (
  rowId: number | string | null | undefined
): boolean => rowId === -1 || rowId === '-1';
